import type { ServiceClient } from '../http/client';
import { ApiError } from '../http/errors';

/** 동기화 결과에는 누락된 기기와 대응하지 못한 지점이 포함된다. */
export interface AccessSyncResult {
  created: number;
  updated: number;
  removed: number;
  skipped_missing_device: number;
  cross_branch_rules: number;
  skipped_missing_branches: string[];
}

/** 미리보기와 반영은 명시적인 dry_run 값으로 구분한다. */
export async function syncAccess(
  client: ServiceClient,
  dryRun: boolean,
): Promise<AccessSyncResult> {
  const value = await client.post<unknown>('admin/access-sync', { json: { dry_run: dryRun } });
  if (!value || typeof value !== 'object' || Array.isArray(value)) throw invalid();
  const row = value as Record<string, unknown>;
  for (const key of [
    'created',
    'updated',
    'removed',
    'skipped_missing_device',
    'cross_branch_rules',
  ]) {
    if (!Number.isSafeInteger(row[key]) || Number(row[key]) < 0) throw invalid();
  }
  if (
    !Array.isArray(row.skipped_missing_branches) ||
    !row.skipped_missing_branches.every((x: unknown) => typeof x === 'string')
  )
    throw invalid();
  return row as unknown as AccessSyncResult;
}
function invalid() {
  return new ApiError({
    kind: 'invalid-response',
    service: 'core',
    message: '출입 동기화 결과를 확인할 수 없습니다.',
  });
}
